<template>
  <div class="structure-conditions-form">
    <div class="row">
      <div class="q-gutter-y-sm col-4">
        <div class="row">
          <q-radio v-model="searchTypeComputed" label="完全一致" val="perfect" color="primary" />
        </div>
      </div>
      <div class="col">
        <div
          :class="[
            'row items-center q-mb-sm',
            searchTypeComputed !== 'perfect' && 'structure-conditions-form-disable',
          ]"
        >
          <div class="col-3 text-right q-mr-sm">立体配置：</div>
          <div class="col">
            <div class="row">
              <q-checkbox
                v-model="ezComputed"
                :disable="searchTypeComputed !== 'perfect'"
                class="q-mr-sm"
                >E/Z一致</q-checkbox
              >
              <q-checkbox v-model="chiralComputed" :disable="searchTypeComputed !== 'perfect'"
                >Chiral一致</q-checkbox
              >
            </div>
          </div>
        </div>
        <div
          :class="[
            'row items-center ',
            searchTypeComputed !== 'perfect' && 'structure-conditions-form-disable',
          ]"
        >
          <div class="col-3 text-right q-mr-sm">Tautomer：</div>
          <div class="col">
            <q-checkbox v-model="tautomerComputed" :disable="searchTypeComputed !== 'perfect'"
              >含む</q-checkbox
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <q-radio v-model="searchTypeComputed" label="部分一致" val="partial" color="primary" />
    </div>
    <div class="row q-mt-sm">
      <div class="col-4">
        <q-radio v-model="searchTypeComputed" label="類似検索" val="similar" color="primary" />
      </div>
      <div
        :class="['col', searchTypeComputed !== 'similar' && 'structure-conditions-form-disable']"
      >
        <div class="row items-center">
          <div class="col">
            <div class="flex items-center">
              <q-input
                v-model="thresholdComputed"
                outlined
                dense
                reverse-fill-mask
                mask="###"
                :disable="searchTypeComputed !== 'similar'"
                input-class="text-right"
                class="input-area"
                style="width: 98px"
                maxlength="3"
              />
              <p class="q-ml-sm q-mb-none">%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  // 検索種類
  searchType: string;
  // ez一致
  ez: boolean;
  // chiral一致
  chiral: boolean;
  // tautomer
  tautomer: boolean;
  // 閾値
  threshold: number;
}

const props = defineProps<Props>();

const emit = defineEmits([
  'changeSearchType',
  'changeEz',
  'changeChiral',
  'changeTautomer',
  'changeThreshold',
]);

// 検索タイプ
const searchTypeComputed = computed({
  get: () => props.searchType,
  set: (value) => {
    emit('changeSearchType', value);
  },
});

// E/Z一致
const ezComputed = computed({
  get: () => props.ez,
  set: (value) => {
    emit('changeEz', value);
  },
});

// Chiral一致
const chiralComputed = computed({
  get: () => props.chiral,
  set: (value) => {
    emit('changeChiral', value);
  },
});

// Tautomer
const tautomerComputed = computed({
  get: () => props.tautomer,
  set: (value) => {
    emit('changeTautomer', value);
  },
});

// 閾値
const thresholdComputed = computed({
  get: () => props.threshold,
  set: (value) => {
    emit('changeThreshold', value);
  },
});
</script>
<style scoped>
.structure-conditions-form .structure-conditions-form-disable {
  opacity: 0.3;
}
</style>
